var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 896,
    height: 912,
    viewBox: "0 0 896 912",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 871.872C669.692 871.872 849.408 685.68 849.408 456C849.408 226.32 669.692 40.128 448 40.128C226.308 40.128 46.592 226.32 46.592 456C46.592 685.68 226.308 871.872 448 871.872Z",
    fill: "#E8F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.754 456.047L526.464 596.539H369.887L369.624 596.073L292.369 734.706L292.632 735.167H448.173H603.721L681.496 595.609L759.266 456.047H604.754Z",
    fill: "url(#paint0_linear_3_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.758 456.047L602.783 459.592H757.295L759.27 456.047H604.758Z",
    fill: "url(#paint1_linear_3_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.464 315.557L604.754 456.049H759.266L681.496 316.49L603.721 176.928H448.173H292.632L292.369 177.395L369.624 316.025L369.887 315.557H526.464Z",
    fill: "url(#paint2_linear_3_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.6 456.051L369.628 316.025L369.371 315.559H215.379L214.859 316.493L137.088 456.051L214.859 595.613L215.379 596.543H369.371L369.628 596.075L291.6 456.051Z",
    fill: "url(#paint3_linear_3_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2",
    x1: 788.9,
    y1: 441.285,
    x2: 295.928,
    y2: 782.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#007FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#0077A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#024D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#035295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9434,
    stopColor: "#0178A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026E9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2",
    x1: 763.852,
    y1: 402.442,
    x2: 79.6735,
    y2: 828.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    stopColor: "#372751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6613,
    stopColor: "#3C2750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7351,
    stopColor: "#46274E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7912,
    stopColor: "#54274B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    stopColor: "#652647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    stopColor: "#792442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#90213C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9422,
    stopColor: "#AA1D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#C61528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#E00518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60013"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2",
    x1: 312.26,
    y1: 142.15,
    x2: 819.435,
    y2: 424.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#0077A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#008EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2",
    x1: 163.54,
    y1: 687.236,
    x2: 454.149,
    y2: 201.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0869,
    stopColor: "#E61912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2169,
    stopColor: "#E83B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3741,
    stopColor: "#EB5E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5524,
    stopColor: "#F18800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7484,
    stopColor: "#F9B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0be6065e4e9aadc8e1224efd0dbc7d8c.svg";
export { ForwardRef as ReactComponent };